<template>
  <el-config-provider
    :namespace="namespace"
    :locale="locale"
  >
    <router-view />
  </el-config-provider>
</template>

<script lang="ts" setup>
  import { ref } from 'vue';
  import { ElConfigProvider } from 'element-plus';
  import zhCn from 'element-plus/dist/locale/zh-cn.mjs';
  import { SessionStorageService, LocalStorageService } from '@/utils/storage';

  const namespace = ref(import.meta.env.VITE_APP_NAME);
  const locale = ref(zhCn);

  // 清除storage中过期的内容
  LocalStorageService.clearExpired();
  SessionStorageService.clearExpired();
</script>
